import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Global one-click shield: the same button/link cannot fire twice within 1.5s.
// After the window passes (or the action finishes/fails), the next click works normally.
const CLICK_GUARD_MS = 1500;
document.addEventListener("click", (e) => {
  const el = e.target.closest("button, a[href], [role='button']");
  if (!el || el.disabled || el.closest("[data-allow-fastclick]")) return;
  const now = Date.now();
  if (el.__lastClickAt && now - el.__lastClickAt < CLICK_GUARD_MS) {
    e.preventDefault();
    e.stopPropagation();
    return;
  }
  el.__lastClickAt = now;
}, true);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
